import React, { useState } from 'react';
import { useQueryClient } from 'react-query';

import closeIcon from 'images/directory/x_icon.svg';

import { useFollowUpdate } from '../../../../../hooks';
import { BasicEntity } from '../../../../../utils/backend-api/entities';
import { FollowAction, FollowType } from '../../../../../utils/backend-api/follow';
import { capitalize } from '../../../../../utils/formatting';
import { Pill } from '../../../../BaseUI';

interface TopicTagProps {
  entity: BasicEntity;
  identityId: number | string;
}

const TopicTag = ({ entity, identityId }: TopicTagProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const queryClient = useQueryClient();
  const { mutateAsync: updateFollow } = useFollowUpdate();

  const handleRemoveTopic = async () => {
    setIsSubmitting(true);
    await updateFollow({
      followType: FollowType.Entity,
      followeeId: entity.id,
      followAction: FollowAction.Unfollow,
      identityId: identityId,
      queryClient,
    });
    setIsSubmitting(false);
  };

  return (
    <Pill
      onClick={handleRemoveTopic}
      className="--neutral"
      /* capitalize first letter of each word (can't use lodash's startCase because it removes special characters) */
      text={capitalize(entity.name)}
      icon={closeIcon}
      disabled={isSubmitting}
    />
  );
};

export default TopicTag;
